<app-navbar [title]="data?.number">
	<button class="btn btn-warning me-4" (click)="deleteAsk()"><i class="fas fa-archive"></i> Archiwizuj</button>
	<button class="btn btn-primary me-4" (click)="edit()"><i class="fas fa-pen"></i> Edytuj</button>
	<button class="btn btn-primary me-4" (click)="bankCardsOwners.showAdd()">
		<i class="fas fa-user-plus"></i> Dodaj właściciela
	</button>
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<app-bank-card-set [data]="data"></app-bank-card-set>

<app-bank-card-owners
	[(card)]="data"
	[ownersTypes]="ownersTypes"
	[users]="users"
	[drivers]="drivers"
	[vehicles]="vehicles"
	[departments]="departments"
	[ownersOther]="ownersOther"
></app-bank-card-owners>
